import { render, staticRenderFns } from "./NotificationsSection.vue?vue&type=template&id=76993e1c&"
import script from "./NotificationsSection.vue?vue&type=script&lang=js&"
export * from "./NotificationsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports